export default {
  // check auth
  get: function get() {
    return localStorage.getItem('ozeit') ? localStorage.getItem('ozeit') : false;
  },
  login: function login(data) {
    if (process.env.NODE_ENV === 'development') {
      localStorage.setItem('ozeit', true);
    } else {
      localStorage.setItem('ozeit', true);
    }
  },
  logout: function logout() {
    localStorage.removeItem('ozeit');
  }
};